var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0625 9.75003H16.5V7.50003C16.5 5.01828 14.4818 3.00003 12 3.00003C9.51825 3.00003 7.5 5.01828 7.5 7.50003V9.75003H6.9375C6.0075 9.75003 5.25 10.5068 5.25 11.4375V19.3125C5.25 20.2433 6.0075 21 6.9375 21H17.0625C17.9925 21 18.75 20.2433 18.75 19.3125V11.4375C18.75 10.5068 17.9925 9.75003 17.0625 9.75003ZM9 7.50003C9 5.84553 10.3455 4.50003 12 4.50003C13.6545 4.50003 15 5.84553 15 7.50003V9.75003H9V7.50003ZM12.75 15.5415V17.25C12.75 17.664 12.4148 18 12 18C11.5852 18 11.25 17.664 11.25 17.25V15.5415C10.8038 15.2813 10.5 14.8028 10.5 14.25C10.5 13.4228 11.1727 12.75 12 12.75C12.8273 12.75 13.5 13.4228 13.5 14.25C13.5 14.8028 13.1962 15.2813 12.75 15.5415Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock .a260f9f5d883822fcf0045f95ef2d4d9.svg";
export { ForwardRef as ReactComponent };